import React from 'react'
import { StyledValue } from './styled'

const Value = ({ item }) => {
    return (
        <StyledValue
            state={item.state}
            rawstate={item.rawstate}
        >
            {item.value}
        </StyledValue>
    )
}

export default Value